// extracted by mini-css-extract-plugin
export default {"custom-sizes":"TihlYE","customSizes":"TihlYE","text-input":"rjed5Y","textInput":"rjed5Y","separator":"VAI767","submit":"iksh09","inactive":"K37W2o"};